const documents = {

  'Persona fisica': {
    // LISTA DOCS
    '2050D08': {
      'name': 'Documento d’identità beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08'
    },
    '2050D09': {
      'name': 'Codice Fiscale beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D06G': {
      'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D08G': {
      'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08G'
    },


    '2050D10A': {
      'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D10A'
    },

    '2050D11A': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11A'
    },

    '2050D12A': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12A'
    },

    '2050D13A': {
      'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13A'
    },
    '2050D19': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
  },

  'Partita IVA': {

    '2050D08G': {
      'name': 'Documento d’identità del Legale Rappresentante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08G'
    },

    '2050D09G': {
      'name': 'Codice Fiscale del Legale Rappresentante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09G'
    },

    '2050D12': {
      'name': 'Visura Camerale Cedente	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },

    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D06G': {
      'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D08G': {
      'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08G'
    },


    '2050D10A': {
      'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D10A'
    },

    '2050D11A': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11A'
    },

    '2050D12A': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12A'
    },

    '2050D13A': {
      'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13A'
    },
    '2050D19': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
  },

  'Amministratore di condominio': {

    '2050D08C': {
      'name': ' Documento di Identità dei Beneficiari	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08C'
    },

    '2050D09C': {
      'name': 'Codice Fiscale dei Beneficiari',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09C'
    },

    '2050D12C': {
      'name': 'Visure Camerale dei Beneficiari	',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12C'
    },

    '2050D18': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D18'
    },

    '2050D16': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16'
    },

    '2050D17': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D17'
    },

    '2050D13': {
      'name': 'Dichiarazione dell’amministratore del condominio/condòminio incaricato che attesti di aver adempiuto a tutti gli obblighi previsti dalla legge e dal quale risulti la ripartizione delle spese e della detrazione per ciascun condòmino	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato%20(1).pdf',

      'codice': '2050D13'
    },

    '2050D20E': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D20E'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D06G': {
      'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    },

    '2050D08G': {
      'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08G'
    },


    '2050D10A': {
      'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D10A'
    },

    '2050D11A': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11A'
    },

    '2050D12A': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12A'
    },

    '2050D13A': {
      'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13A'
    },
    '2050D19': {
      'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D19'
    },
  }

}

export default documents



// WEBPACK FOOTER //
// ./src/components/documents/documentsEmicon.js